import { render, staticRenderFns } from "./detail_card.vue?vue&type=template&id=01aa01cf&scoped=true"
import script from "./detail_card.vue?vue&type=script&lang=js"
export * from "./detail_card.vue?vue&type=script&lang=js"
import style0 from "./detail_card.vue?vue&type=style&index=0&id=01aa01cf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa01cf",
  null
  
)

export default component.exports